import React, { useState } from 'react';
import '../../../styles/allmodules.css';
import SupportTicketModal   from '../support/SupportTicketModal';
import SupportTicketHistory from '../support/SupportTicketHistory';

const IconSupportMgmt = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <circle cx="5" cy="4.5" r="1.8" stroke="currentColor" strokeWidth="1.4"/>
    <circle cx="11" cy="4.5" r="1.8" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M1.5 13c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M8.5 11.5c.5-1.2 1.7-2 3-2 1.9 0 3.5 1.6 3.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M8 9.5c.9-.3 1.7-.5 2.5-.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

// SVG icon components — monochromatic, use currentColor
const IconCore = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <circle cx="8" cy="8" r="5" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="2" fill="currentColor"/>
  </svg>
);
const IconProgrammes = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5 6h6M5 9h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const IconCommunity = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="11" cy="7" r="2" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M1 13c0-2.5 2-4 5-4s5 1.5 5 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M11 11c1.5 0 3 .8 3 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const IconEvents = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5 2v2M11 2v2M2 7h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const IconCommunications = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <path d="M2 3h12a1 1 0 011 1v7a1 1 0 01-1 1H9l-3 2v-2H2a1 1 0 01-1-1V4a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);
const IconReports = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5 10V8M8 10V6M11 10V4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const IconAI = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <path d="M8 2l1.5 3.5L13 7l-3.5 1.5L8 12l-1.5-3.5L3 7l3.5-1.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);


const IconDonors = () => (
  <svg viewBox="0 0 16 16" fill="none" width="26" height="26">
    <path d="M8 2C9.1 2 10 2.9 10 4s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M3 13c0-2.2 2-4 5-4s5 1.8 5 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M12 7l1.5 1.5M13.5 7L12 8.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const MODULES = [
  {
    id: 'core',
    label: 'Core',
    icon: <IconCore />,
    description: "Configure your organisation's branding, contact details, imagery, typography and custom styling.",
    tools: ['Brand Identity', 'About Us', 'Contact Info', 'Office Hours', 'Image Management', 'Typography', 'Custom CSS'],
    groupId: 'core',
    firstTab: 'branding',
  },
  {
    id: 'programmes',
    label: 'Programmes Management',
    icon: <IconProgrammes />,
    description: 'Manage government schemes and organisation programmes.',
    tools: ['Government Programmes', 'Organisation Programmes'],
    groupId: 'programmes',
    firstTab: 'govSchemes',
    moduleKey: 'programmes',
  },
  {
    id: 'community',
    label: 'Community Management',
    icon: <IconCommunity />,
    description: 'Oversee volunteer profiles, volunteer segmentation, member profiles and member segmentation.',
    tools: ['Volunteer Profiles', 'Volunteer Segmentation', 'Member Profiles', 'Member Segmentation'],
    groupId: 'community',
    firstTab: 'volunteerProfiles',
    moduleKey: 'community',
  },
  {
    id: 'supportmgmt',
    label: 'Support Management',
    icon: <IconSupportMgmt />,
    description: 'Manage job board listings, support network groups, mentoring pairs and peer connections.',
    tools: ['Job Board', 'Support Network'],
    groupId: 'supportmgmt',
    firstTab: 'jobBoard',
    moduleKey: 'supportmgmt',
  },
  {
    id: 'events',
    label: 'Events\nManagement',
    icon: <IconEvents />,
    description: 'Set up events, handle registrations and waitlists, track attendance, manage the event calendar and media.',
    tools: ['Event Setup', 'Registration & Waitlist', 'Attendance & Check-In', 'Event Calendar', 'Content & Media'],
    groupId: 'events',
    firstTab: 'eventSetup',
    moduleKey: 'events',
  },
  {
    id: 'communications',
    label: 'Communications Management',
    icon: <IconCommunications />,
    description: 'Send email campaigns, push notifications and WhatsApp messages. View full campaign listing and history.',
    tools: ['Email Campaigns', 'Push Notifications', 'WhatsApp Campaigns', 'Campaigns Listing'],
    groupId: 'communications',
    firstTab: 'emailCampaigns',
    moduleKey: 'communications',
  },
  {
    id: 'reports',
    label: 'Reports\nManagement',
    icon: <IconReports />,
    description: 'Build custom queries, explore analytics dashboards, and access engagement and volunteer reports.',
    tools: ['Query Builder', 'Analytics Dashboard', 'Engagement Report', 'Volunteer Report'],
    groupId: 'reports',
    firstTab: 'queryBuilder',
    moduleKey: 'reports',
  },
  {
    id: 'bespokeai',
    label: 'Bespoke AI',
    icon: <IconAI />,
    description: 'Leverage AI-powered tools for community insights, communications drafting, events intelligence and report generation.',
    tools: ['Community AI', 'Communications AI', 'Events AI', 'Reports AI'],
    groupId: 'bespokeai',
    firstTab: 'communityAI',
    moduleKey: 'bespokeai',
  },
  {
    id: 'donors',
    label: 'Donor Management',
    icon: <IconDonors />,
    description: 'Manage donor relationships, track grant KPIs, log communications and monitor donor activity and alerts.',
    tools: ['Donor Profiles', 'Contact CRM', 'Grants & KPIs', 'Comms Log', 'Timeline & Alerts'],
    groupId: 'donors',
    firstTab: 'donorProfiles',
    moduleKey: 'donors',
  },
];

const TOOL_MAP = {
  core:           ['branding', 'aboutUs', 'contact', 'officeHours', 'images', 'typography', 'customCSS'],
  programmes:     ['govSchemes', 'orgProgrammes'],
  community:      ['volunteerProfiles', 'volunteerSegmentation', 'memberProfiles', 'memberSegmentation'],
  supportmgmt:    ['jobBoard', 'supportNetwork'],
  events:         ['eventSetup', 'registrations', 'attendance', 'calendar', 'mediaContent'],
  communications: ['emailCampaigns', 'pushCampaigns', 'whatsappCampaigns', 'campaignListing'],
  reports:        ['queryBuilder', 'analyticsDashboard', 'engagementReport', 'volunteerReport'],
  bespokeai:      ['communityAI', 'communicationsAI', 'eventsAI', 'reportsAI'],
  donors:         ['donorProfiles', 'donorContacts', 'donorGrants', 'donorComms', 'donorTimeline'],
};

// Render label with line break for labels containing \n
function ModuleLabel({ label }) {
  if (!label.includes('\n')) return <>{label}</>;
  const parts = label.split('\n');
  return (
    <>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {part}
          {i < parts.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
}

function AllModules({ onNavigate, orgId, currentUser, enabledModules }) {
  const [showTicketModal,   setShowTicketModal]   = useState(false);
  const [showTicketHistory, setShowTicketHistory] = useState(false);

  // Bespoke AI sub-tools are switched off individually by the SuperAdmin (only an explicit
  // `false` hides one), so its tool list and tab targets are filtered to match.
  const visibleModules = MODULES
    .filter(m => {
      if (!m.moduleKey) return true;
      if (!enabledModules) return true;
      return !!enabledModules[m.moduleKey];
    })
    .map(m => {
      if (m.id !== 'bespokeai' || !enabledModules) return m;
      const tabs = TOOL_MAP.bespokeai.filter(tabId => enabledModules[tabId] !== false);
      return {
        ...m,
        tools:    m.tools.filter((_, i) => enabledModules[TOOL_MAP.bespokeai[i]] !== false),
        toolTabs: tabs,
        firstTab: tabs[0],
      };
    })
    .filter(m => m.tools.length > 0);

  const premiumToolCount = visibleModules.find(m => m.id === 'bespokeai')?.tools.length || 0;

  const handleOpenModule = (mod) => {
    if (onNavigate) onNavigate(mod.groupId, mod.firstTab);
  };

  const handleToolClick = (mod, toolIndex) => {
    if (!onNavigate) return;
    const tabs  = mod.toolTabs || TOOL_MAP[mod.groupId] || [];
    const tabId = tabs[toolIndex] || tabs[0];
    if (tabId) onNavigate(mod.groupId, tabId);
  };

  // Show ticket history as full-page replacement
  if (showTicketHistory) {
    return (
      <SupportTicketHistory
        orgId={orgId}
        currentUser={currentUser}
        onBack={() => setShowTicketHistory(false)}
      />
    );
  }

  return (
    <div className="bb-allmodules">
      {/* ── Ticket submission modal ── */}
      {showTicketModal && orgId && (
        <SupportTicketModal
          orgId={orgId}
          currentUser={currentUser}
          onClose={() => setShowTicketModal(false)}
        />
      )}

      {/* ── Header ── */}
      <div className="bb-allmodules-header">
        <h2>BespokeBridge Management Modules</h2>
        <p>Select a module to access its management tools and features</p>
      </div>

      {/* ── Overview stats ── */}
      <div className="bb-allmodules-stats">
        <div className="bb-allmodules-stat">
          <span className="bb-allmodules-stat-number">{visibleModules.length}</span>
          <span className="bb-allmodules-stat-label">Active Modules</span>
        </div>
        <div className="bb-allmodules-stat">
          <span className="bb-allmodules-stat-number">{visibleModules.reduce((acc, m) => acc + m.tools.length, 0)}</span>
          <span className="bb-allmodules-stat-label">Available Tools</span>
        </div>
        <div className="bb-allmodules-stat">
          <span className="bb-allmodules-stat-number">{premiumToolCount}</span>
          <span className="bb-allmodules-stat-label">Premium Tools</span>
        </div>
      </div>

      {/* ── Module cards ── */}
      <div className="bb-allmodules-grid">
        {visibleModules.map(mod => (
          <div
            key={mod.id}
            className={`bb-module-card${mod.id === 'core' ? ' bb-module-card--core' : ''}`}
            onClick={() => handleOpenModule(mod)}
          >
            <div className="bb-module-card-header">
              <div className="bb-module-card-title-col">
                <h3 className="bb-module-card-title">
                  <ModuleLabel label={mod.label} />
                </h3>
                <span className="bb-module-card-badge">Active</span>
              </div>
              <span className="bb-module-card-icon">{mod.icon}</span>
            </div>

            <p className="bb-module-card-desc">{mod.description}</p>

            <div className="bb-module-card-tools">
              <h4>Management Tools · {mod.tools.length}</h4>
              <div className="bb-module-tools-grid">
                {mod.tools.slice(0, 6).map((tool, i) => (
                  <div
                    key={i}
                    className="bb-module-tool-item"
                    onClick={e => { e.stopPropagation(); handleToolClick(mod, i); }}
                  >
                    {tool}
                  </div>
                ))}
                {mod.tools.length > 6 && (
                  <div className="bb-module-tool-item" style={{ fontStyle: 'italic', opacity: 0.7 }}>
                    +{mod.tools.length - 6} more
                  </div>
                )}
              </div>
            </div>

            <div className="bb-module-card-footer">
              <button
                className="bb-module-open-btn"
                onClick={e => { e.stopPropagation(); handleOpenModule(mod); }}
              >
                Open Module
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ── Need Help? ── */}
      <div className="bb-allmodules-help">
        <h3>Need Help?</h3>
        <div className="bb-allmodules-help-cards">

          <div className="bb-allmodules-help-card">
            <h4>Getting Started</h4>
            <p>
              New to BespokeBridge? Click{' '}
              <a
                className="bb-allmodules-help-link"
                href="https://www.bespokecrm.cloud"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>{' '}
              for the online training manual to get assistance navigating the platform.
            </p>
          </div>

          <div className="bb-allmodules-help-card">
            <h4>Technical Support</h4>
            <p>
              <button
                className="bb-allmodules-help-link"
                onClick={() => setShowTicketModal(true)}
              >
                Submit a support ticket
              </button>{' '}
              for bug reports, troubleshooting and technical assistance.
            </p>
            <p style={{ marginTop: '0.5rem' }}>
              <button
                className="bb-allmodules-help-link"
                onClick={() => setShowTicketHistory(true)}
              >
                View my tickets
              </button>
            </p>
          </div>

          <div className="bb-allmodules-help-card">
            <h4>Other Services</h4>
            <p>
              Click{' '}
              <a
                className="bb-allmodules-help-link"
                href="https://www.bespokecrm.cloud"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>{' '}
              to find out more about other services Bespoke CRM offers to add value to your organisation.
            </p>
          </div>

          <div className="bb-allmodules-help-card">
            <h4>Upgrade Features</h4>
            <p>
              Contact{' '}
              <a
                className="bb-allmodules-help-link"
                href="mailto:sales@bespokecrm.cloud"
              >
                sales
              </a>{' '}
              to unlock premium modules and enhance your organisation's capabilities.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AllModules;
